import axios from "axios";
import { endpoints } from "config/api";
import { getAuthToken } from "utils/helper";

export const getAllDisputed = async (params) => {
  let request = await axios({
    method: "GET",
    url: endpoints.disputed.GET_ALL_DISPUTED,
    headers: {
      Authorization: getAuthToken(),
    },
    params: params,
  });
  return request;
};

export const updateDispute = async (data) => {
  let request = await axios({
    method: "PUT",
    url: `${endpoints.disputed.UPDATE_DISPUTED}`,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};

export const getDisputeHistory = async (params) => {
  let request = await axios({
    method: "GET",
    url: endpoints.disputed.DISPUTE_HISTORY,
    headers: {
      Authorization: getAuthToken(),
    },
    params: params,
  });
  return request;
};

export const getDisputeById = async (id, data) => {
  let request = await axios({
    method: "GET",
    url: `${endpoints.disputed.GET_DISPUTED_BY_ID}?buyerId=${id}`,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};

export const deleteDisputeById = async (data) => {
  let request = await axios({
    method: "PUT",
    url: endpoints.disputed.DELETE_DISPUTED_BY_ID,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};

export const addDispute = async (data) => {
  let request = await axios({
    method: "POST",
    url: `${endpoints.disputed.ADD_DISPUTED}`,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};

//Create New payment process
export const crateNewPaymentProcess = async (data) => {
  let request = await axios({
    method: "POST",
    url: endpoints.disputed.CREATE_NEW_PAYMENT,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};
